import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FrostedOverlay } from '@stvgroup/stv-ui-components'
import { toggleSearch } from '../../actions'
import Search from './index'

/**
 * A container that renders the search overlay.
 * The visibility of the overlay is controlled by the `programmeSearchIsActive` prop
 * from the Redux store.
 * @param {boolean} programmeSearchIsActive - Flag indicating if the search overlay is active.
 * @param {Function} handleToggleSearch - Function to toggle the visibility of the
 * search overlay.
 */
const SearchContainer = ({ programmeSearchIsActive, handleToggleSearch }) => {
  // Render nothing if the search is not active.
  if (!programmeSearchIsActive) return null

  return (
    <FrostedOverlay id="overlay-container" sx={{ zIndex: 1000 }}>
      <Search toggleSearch={handleToggleSearch} />
    </FrostedOverlay>
  )
}

SearchContainer.propTypes = {
  programmeSearchIsActive: PropTypes.bool,
  handleToggleSearch: PropTypes.func.isRequired,
}

SearchContainer.defaultProps = {
  programmeSearchIsActive: false,
}

// Maps state from the Redux store to component props.
const mapStateToProps = state => ({
  programmeSearchIsActive: state?.programmeSearch?.isActive,
})

// Maps action creators to component props.
const mapDispatchToProps = {
  handleToggleSearch: toggleSearch,
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer)
